"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _internal = _interopRequireDefault(require("../styles/internal"));
var InternalTheme = function InternalTheme(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: _internal["default"]
  }, children);
};
InternalTheme.propTypes = {
  children: _propTypes["default"].node.isRequired
};
var _default = exports["default"] = InternalTheme;